import CarouselView from './carousel-view'

export default CarouselView
